/**
 * Scorecard Tab Wrapper
 * Wrapper component to be used in InterviewTabs
 * Handles visibility mode switching
 */

import React from 'react';
import { ScorecardWithVisibility } from './ScorecardWithVisibility';
import { type GroupedScorecards, type ScorecardVisibilityMode } from '../types';
import { type InterviewType } from '@/types/interview';

interface ScorecardTabWrapperProps {
  interview: InterviewType;
  interviewId?: string | number;
  scorecardVisibilityMode?: ScorecardVisibilityMode;
  apiGroupedScorecards?: GroupedScorecards;
  hasCurrentUserSubmitted: boolean;
  tabId: string;
  refetchScorecardVisibility: () => void;
}

export const ScorecardTabWrapper = React.memo(function ScorecardTabWrapper({
  interview,
  apiGroupedScorecards,
  scorecardVisibilityMode,
  hasCurrentUserSubmitted,
  tabId,
  refetchScorecardVisibility,
}: ScorecardTabWrapperProps) {
  const visibilityMode: ScorecardVisibilityMode =
    scorecardVisibilityMode || 'never';

  // this has the logic for showing the scorecard based on the visibility mode
  return (
    <ScorecardWithVisibility
      interview={interview}
      apiGroupedScorecards={apiGroupedScorecards}
      visibilityMode={visibilityMode}
      hasCurrentUserSubmitted={hasCurrentUserSubmitted}
      tabId={tabId}
      refetchScorecardVisibility={refetchScorecardVisibility}
    />
  );
});
